<template>
  <div>
    <br />
    <b-row class="text-left">
      <b-col>
        <h5 class="text-primary font-weight-bold">
          {{items.product_location_name}} - {{items.payment_method_name}}
        </h5>
        <br />
        <!-- <h5>
          <router-link
            :to="{ name: 'PaymentInstruction' }"
            class="text-primary text-decoration-none"
          >
            <i class="fas fa-long-arrow-alt-left mr-2"></i>Kembali
          </router-link>
        </h5> -->
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        <b-card class="text-left">
          <h6><b>Payment Instruction</b></h6>
              <div v-for="(data, l) in items.instruction"
              :key="l">
              <b-row class="mt-4">
                <b-col md="6">
                  <b-form-group
                    id="fieldset-1"
                    label="Instruction Name"
                    label-class="control-label"
                    class="required"
                    label-for="input-1"
                  >
                    <input
                      v-validate="'required'"
                      v-model="data.name"
                      name="instruction_name"
                      data-vv-as="Instruction Name"
                      id="input-1"
                      class="form-control"
                      placeholder="Instruction Name"
                    />
                    <b-form-invalid-feedback id="input-instruction_name-feedback">{{ veeErrors.first('instruction_name') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col class="align-self-center">
                  <label v-show="items.instruction.length > 1" @click="remove_instruction(l)" class="text-danger mt-3" style="cursor: pointer;">
                    <i class="far fa-trash-alt"></i> Delete Instruction
                    </label>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="fieldset-1"
                    label="Instruksi (Bahasa)"
                    label-class="control-label"
                    class="required"
                    label-for="input-1"
                  >
                    <ckeditor
                      :editor="editor"
                      tag-name="textarea"
                      v-validate="'required'"
                      v-model="data.description_id"
                      name="instruction_id"
                      data-vv-as="Instruksi (Bahasa)"
                      placeholder="Instruksi (Bahasa)"
                      class="form-control"
                      :config="editorConfig"
                      ></ckeditor>
                    <b-form-invalid-feedback id="input-instruction_id-feedback">{{ veeErrors.first('instruction_id') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    id="fieldset-1"
                    label="Instruksi (English)"
                    label-class="control-label"
                    class="required"
                    label-for="input-1"
                  >
                      <ckeditor
                      :editor="editor"
                      tag-name="textarea"
                      v-validate="'required'"
                      v-model="data.description_en"
                      name="instruction_en"
                      data-vv-as="Instruksi (English)"
                      placeholder="Instruksi (English)"
                      class="form-control"
                      :config="editorConfig"
                      ></ckeditor>
                    <b-form-invalid-feedback id="input-instruction_en-feedback">{{ veeErrors.first('instruction_en') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-button 
                  @click="add_instruction()"
                  v-show="l == items.instruction.length - 1"
                   block variant="outline-primary"> <i class="fas fa-plus"></i>Add Instruction</b-button>
                </b-col>
              </b-row>
              </div>
              <br />
            <b-row class="text-right">
              <b-col md="2" class="text-left">
                <label class="text-danger">
                  <b class="text-dark"><span class="text-danger font-weight-bold">*</span> Required</b>
                </label>
              </b-col>
              <b-col>
                <b-button variant="primary" :disabled="loading" @click="edit()" class="mr-3" size="lg">
                  Update
                  <b-spinner v-if="loading" small label="Loading..."></b-spinner>
                </b-button>
                <router-link :to="{name: 'PaymentInstruction'}">
                  <b-button variant="outline-secondary" size="lg">Cancel</b-button>
                </router-link>
              </b-col>
            </b-row>
        
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";

export default {
  mixins: [mixInCkeditor],
  data() {
    return {
      editor: ClassicEditor,
      session: this.$session.get("jwt"),
      widthImage: null,
      heightImage: null,
      loading: false,
      loadingRefund: false,
      items: [],
      member: [],
      amount: "",
      reason: "",
      urlImage: "",
      modalImage: false,
      refundShow: false,
      image: "",
      date: new Date(),
      timestamp: "",
      hour: new Date().getHours(),
      minute: new Date().getMinutes(),
      second: new Date().getSeconds(),
      utc: new Date().getUTCDate(),
      time: new Date().getHours(),
      compare: new Date("October 13, 2020 11:13:00"),
    };
  },
  async beforeCreate() {
    this.$store
      .dispatch(
        "PaymentInstructionModule/getDetailInstruction",
        {id:this.$route.params.id,product:this.$route.params.product}
      )
      .then((response) => {
        this.items = response;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  created() {
    // this.hitt();
  },
  computed: {
    
  },
  methods: {
    add_instruction(){
      this.items.instruction.push({
        description_en: "",
        description_id: "",
        name: ""
      });
    },
    remove_instruction(data){
      this.items.instruction.splice(data, 1);
    },
    edit(){
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Instruction!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              $.each(this.items.instruction, (index, value) => {
                formData.append("instruction[sequence]", index);
                formData.append(`instruction[name][${index}]`, value.name);
                formData.append(`instruction[description_id][${index}]`, value.description_id);
                formData.append(`instruction[description_en][${index}]`, value.description_en);
              })
              this.$store
                .dispatch("PaymentInstructionModule/putInstruction", {
                  id: this.$route.params.id,
                  product:this.$route.params.product,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "PaymentInstruction" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: this.$validator.errors.all(),
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        }
      });
    }
  },
};
</script>

<style>
</style>